/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'sharp/image/crop': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M14.166 12.5h1.667V4.167H7.5v1.666h6.666V12.5zm-8.333 1.667V.833H4.166v3.334H.833v1.666h3.333v10h10v3.334h1.667v-3.334h3.333v-1.666H5.833z" _fill="#fff"/>'
  }
})
